export default {
  name: 'time-picker',
  label: '时间',
  icon: 'el-icon-time',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请选择时间'
    }
  }] // draggable: true // TODO: 可在设计界面拖放的控件

};